/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBPARTYTYPE = {
    Individual: 'I',
    Trust: 'T',
    Company: 'C',
    NonTaxableInstitute: 'N'
} as const;
export type GHUBPARTYTYPE = typeof GHUBPARTYTYPE[keyof typeof GHUBPARTYTYPE];


export function GHUBPARTYTYPEFromJSON(json: any): GHUBPARTYTYPE {
    return GHUBPARTYTYPEFromJSONTyped(json, false);
}

export function GHUBPARTYTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBPARTYTYPE {
    return json as GHUBPARTYTYPE;
}

export function GHUBPARTYTYPEToJSON(value?: GHUBPARTYTYPE | null): any {
    return value as any;
}

